const DOCUMENT = 'SPRINT_MA';

const actions = {
  INIT_DATA: DOCUMENT + 'INIT_DATA',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  TOUCH: DOCUMENT + 'TOUCH',
  SAVE: DOCUMENT + 'SAVE',

  initData: data => {
    return {
      type: actions.INIT_DATA,
      payload: data,
    };
  },

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),
};

export default actions;
